import {
  Button, Container,
  Form, FormField,
  Header,
  Input, RadioGroup, Select, SpaceBetween, TimeInput
} from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { addDays, format, isValid, parse } from 'date-fns';
import React, { useEffect, useState } from 'react';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemMailTemplate } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
const _preserve = React.version;

export const CommMailingsCreatePage = () => {
  const { menu } = useGlobalState();
  const { navigate } = useRouter();
  const [mailTemplates, setMailTemplates] = useState<ItemMailTemplate[]>([]);
  const [isInvalidMailTemplate, setIsInvalidMailTemplate] = useState(true);

  const [mailTemplate, setMailTemplate] = useState<ItemMailTemplate>({
    idMailTemplate: 0, status: 0, subject: '', idGroups: [], idStatuses: [],
    idCharges: [], idChecks: [], idUserTypes: [], html: '',
    dateSend: format(addDays(new Date(), 1), "dd-MM-yyyy"), timeSend: format(new Date(), "HH:mm")
  });


  const handleGetTemplates = async () => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/mailings/list',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          "limit": 25,
          "columns": "idMailTemplate,  subject, html, replyTo, status, dateCreated, dateModified, dateSend, isActiveMailTemplate, isDeleteMailTemplate, copy, idCharges, idChecks, idUserTypes, idStatuses, idGroups, cc",
          "orderBy": "dateSend",
          "order": "desc"
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0 && data.mailTemplates) {
        setMailTemplates(data.mailTemplates);

      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }

  const handleCopyEmail = async () => {
    try {
      setLoading(true)
      let payloadTemplate = {
        ...mailTemplate,
        status: 0, dateSend: format(addDays(new Date(), 2), "dd-MM-yyyy") + " 12:00",
        subject: "[COPIA] " + mailTemplate.subject
      };
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/mailings/copy',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(payloadTemplate),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0 && data.idMailTemplate) {
        navigate('comm/mailings/queue?id=' + data.idMailTemplate);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }

  const handleCreateEmail = async () => {
    try {
      setLoading(true)
      let payloadTemplate = {
        ...mailTemplate,
        dateSend: mailTemplate.dateSend + " " + mailTemplate.timeSend
      };
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/mailings/add',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(payloadTemplate),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0 && data.idMailTemplate) {
        navigate('comm/mailings/queue?id=' + data.idMailTemplate);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  useEffect(() => {
    handleGetTemplates();
  }, []);
  useEffect(() => {
    let isInvalid = false;
    if (selectedType === "NEW") {
      if (mailTemplate.subject.trim().length <= 10) {
        isInvalid = true;
      }
      const parsedDate = parse(mailTemplate.dateSend + " " + mailTemplate.timeSend, "dd-MM-yyyy HH:mm", new Date());
      const isDateTimeValid = isValid(parsedDate);
      if (!isDateTimeValid) {
        isInvalid = true;
      }
    } else if (selectedType === "TEMPLATE") {
      if (!mailTemplate.idMailTemplate) {
        isInvalid = true;
      }

    }
    setIsInvalidMailTemplate(isInvalid);

  }, [mailTemplate]);
  const [selectedType, setSelectedType] = useState("");

  // Define simple radio items
  const radioItems = [
    { value: 'NEW', label: 'Nuevo email', description: 'Crear un correo desde cero' },
    { value: 'TEMPLATE', label: 'Desde una plantilla', description: 'Seleccionar un mailing anterior' }
  ];

  // Helper to find the formatted option for the Select
  const selectedTemplateOption = mailTemplates.find(t => t.idMailTemplate === mailTemplate.idMailTemplate);

  useEffect(() => {
    handleGetTemplates();
  }, []);

  useEffect(() => {
    let isInvalid = mailTemplate.subject.trim().length <= 10;
    const parsedDate = parse(mailTemplate.dateSend + " " + mailTemplate.timeSend, "dd-MM-yyyy HH:mm", new Date());
    if (!isValid(parsedDate)) isInvalid = true;
    setIsInvalidMailTemplate(isInvalid);
  }, [mailTemplate]);


  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={<BreadcrumbGroup items={buildBreadcrumbItems(menu)} ariaLabel="Breadcrumbs" />}
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Crear email</Header>

          <Form actions={
            selectedType !== "" && (
              <Button disabled={isInvalidMailTemplate} variant="primary" onClick={() => {
                if (selectedType === "NEW") {
                  handleCreateEmail();
                } else {
                  handleCopyEmail();
                }
              }}>
                {selectedType === "NEW" ? "Crear" : "Copiar"}
              </Button>
            )}
          >
            <Container>
              <SpaceBetween direction="vertical" size="l">
                {/* 1. Selection Method */}
                <FormField label="Método de creación">
                  <RadioGroup
                    direction='horizontal'
                    onChange={({ detail }) => setSelectedType(detail.value)}
                    value={selectedType}
                    items={radioItems}
                  />
                </FormField>

                <hr style={{ border: '0', borderTop: '1px solid #eaeded' }} />

                {/* 2. Conditional Form Content - MOVED OUTSIDE THE RADIO ITEMS */}
                {selectedType === "NEW" && (
                  <SpaceBetween direction="vertical" size="m">
                    <FormField label="Asunto">
                      <Input
                        placeholder="Asunto del email"
                        value={mailTemplate.subject}
                        onChange={({ detail }) => setMailTemplate({ ...mailTemplate, subject: detail.value })}
                      />
                    </FormField>

                    <FormField label="Fecha y hora de envío">
                      <SpaceBetween direction="horizontal" size="s">
                        <DPModal start={new Date()} date={mailTemplate?.dateSend} onConfirm={(date) => {
                          setMailTemplate({ ...mailTemplate, dateSend: date });
                        }} />
                        <TimeInput format='hh:mm' placeholder="Hora" value={mailTemplate?.timeSend || ''} onChange={(e) => {
                          setMailTemplate({ ...mailTemplate, timeSend: e.detail.value });
                        }} />



                      </SpaceBetween>
                    </FormField>
                  </SpaceBetween>
                )}
                {selectedType === "TEMPLATE" && (
                  <FormField label="Selecciona una plantilla">
                    <Select
                      selectedOption={selectedTemplateOption ? {
                        value: selectedTemplateOption.idMailTemplate.toString(),
                        label: selectedTemplateOption.subject
                      } : null}
                      options={mailTemplates.map((t) => ({
                        value: t.idMailTemplate.toString(),
                        label: `[${t.dateSend}] ${t.subject}`
                      }))}
                      onChange={({ detail }) => {
                        const selected = mailTemplates.find(t => t.idMailTemplate.toString() === detail.selectedOption.value);
                        if (selected) {
                          setMailTemplate({
                            ...selected,
                            dateSend: format(new Date(), "dd-MM-yyyy"),
                            timeSend: format(new Date(), "HH:mm")
                          });
                        }
                      }}
                      placeholder="Busca una plantilla..."
                      filteringType="auto"
                    />
                  </FormField>
                )}
              </SpaceBetween>
            </Container>
          </Form>
        </SpaceBetween>
      }
    />
  );
};